import { ITask } from "./ITask";

export class TaskStorage {
    private readonly inProgressTasks: Map<string, ITask> = new Map();

    public getTask(storageId: undefined | string): ITask | undefined {
        if (storageId == undefined) {
            return undefined;
        }
        return this.inProgressTasks.get(storageId);
    }

    public setTask(id: string, task: ITask): void {
        this.inProgressTasks.set(id, task);
    }

    public deleteTask(storageId: string): void {
        this.inProgressTasks.delete(storageId);
    }
}
